import { useEffect, useState } from "react"
import { useApp } from '../../../../../context/App';
import { INews } from '../../../../../types/news';
import { parseDate } from "../../../../../utils/date";

interface Props {
	news: INews
}

export function BottomNews({ news }: Props) {
	const { configDomainURL } = useApp()
	const domain = configDomainURL
	const [thumb, setThumb] = useState<string>('')

	useEffect(() => {
		if (!!news.img) {
			const thumbArray = news.img.split("/");
			const nome_imagem = thumbArray[thumbArray.length - 1];
			const thumb_url = 'https://api-portal.itajai.sc.gov.br/public/portaladm-pmitajai/noticias/tn/'
			setThumb(thumb_url + nome_imagem)
		}
	}, [news.img])

	const link_montado = news.title
		.toLowerCase()
		.replaceAll(' ', '-')
		.replaceAll('/', '-')
		.replaceAll(new RegExp('[&/\\\\#,+()$~%.\'":*?<>{}]', 'g'), '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, "")

	return (
		<a
			href={`${domain}noticias/${news.newsId}/${link_montado}`}
			className="flex flex-col bg-surface-secondary dark:bg-surface-dark-secondary rounded-2xl overflow-hidden no-underline shadow-md dark:shadow-premium-dark hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] group border border-border-default dark:border-white/10"
		>
			<div className="flex p-3 gap-3">
				{!!news.img && (
					<div
						className="w-20 h-20 flex-shrink-0 bg-no-repeat bg-center bg-cover rounded-lg shadow-inner dark:opacity-90"
						style={{
							backgroundImage: "url(" + thumb + ")",
						}}
					></div>
				)}

				<div className="flex flex-col justify-center gap-1 overflow-hidden">
					<h4 className="text-on-surface dark:text-on-surface-dark font-bold text-xs leading-tight line-clamp-3 transition-colors duration-200 group-hover:text-primary dark:group-hover:text-secondary">
						{news.title}
					</h4>
					<span className="text-[10px] uppercase tracking-widest text-on-surface-subtle dark:text-on-surface-dark-muted font-medium mt-1">
						{parseDate(news.published)}
					</span>
				</div>
			</div>
		</a>
	)
}